export class UnableToLoadPageDataError extends Error {
  message: string;

  constructor(message: string) {
    super(`Unable to load page data. Details: ${message}`);
    this.message = message;
  }
}
